import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
    name: 'auth',
    initialState: {isLoisLoggedIn: true},
    reducers: {
        logout(state) {
            state.isLoisLoggedIn = false
        }
    }
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;